import { Link } from "react-router-dom";
import img1 from "../../assets/images/npskudlu.jpg";

const AboutThree = () => {
  return (
    <section className="about-two py-80 position-relative z-1">
      <div className="position-relative">
        <div className="container">
          <div className="row gy-xl-0 gy-5 align-items-center">
            {/* Image */}
            <div className="col-xl-6">
              <div className="about-two__thumb position-relative">
                <img
                  src={img1}
                  alt="National Public School Kudlu Campus"
                  className="rounded-16 cover-img"
                  data-aos="zoom-in" // smooth zoom effect
                  data-aos-duration="1000" // duration in ms
                  data-aos-easing="ease-out" // easing curve
                />
              </div>
            </div>

            {/* Content */}
            <div className="col-xl-6">
              <div className="about-two-content">
                <div className="mb-40">
                  <div
                    className="flex-align d-inline-flex gap-8 mb-16"
                    data-aos="fade-down"
                    data-aos-duration="800"
                  >
                    <h5 className="text-main-600 mb-0">Welcome to</h5>
                  </div>

                  <h1
                    className="mb-24"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="1000"
                  >
                    National Public School Kudlu – Best CBSE School in Bengaluru
                  </h1>

                  <p
                    className="text-neutral-500 text-line-2"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    data-aos-duration="1200"
                  >
                    National Public School Kudlu is one of the leading CBSE schools in Bengaluru, dedicated to provide quality education and holistic development. Our experienced faculty, modern infrastructure, innovative teaching methods,and student-focused learning environment help every child achieve academic excellence while developing confidence, creativity, and leadership skills. We believe in nurturing young minds through academics, sports, arts, and co-curricular activities to prepare them for a successful future. <br />Admissions are now open for
                    the academic year 2026–27.
                  </p>
                </div>

                <div
                  className="pt-20 mt-20 border-dashed border-0"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <Link
                    to="/about-us"
                    className="btn btn-main rounded-pill flex-align d-inline-flex gap-8"
                  >
                    Know More
                    <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutThree;
